export default {
  search_result: 'Здесь будут отображаться результаты поиска менеджеров',
  correspondence: 'Здесь будет отображаться ваша переписка с менеджером',
  companions: 'Здесь будут выводиться ваши собеседники',
  was_online: 'Был(а) {interval} назад',
  online: 'Онлайн',
  new_message: 'Новое сообщение',
  mail_conversation_manager: 'Почта с {manager}',
}
